import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/weave-rewind.webp';

const thumbHashString = '8IeFFIQTMKmliZi4RwaUMJSoZgSZOIdaBA==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.2740740740740741;
const originalWidth = 344;

const WeaveRewind = ({ aspectRatio = calculatedAspectRatio, width = originalWidth, ...rest }: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default WeaveRewind;
